module.exports = __webpack_public_path__ + "static/media/Side Scroller still.90ecea1a.PNG";